import * as $ from 'jquery';
import 'jquery-colorbox';

import siteLightboxOptions from './siteLightboxOptions';

export default function init() {
	const $elem = $('a[href*="send-message.html"]');

	const options = $.extend({}, siteLightboxOptions('formLightbox'), {
		html: function(){
			var fullHtml = '';
			$.ajax({
				url: $elem.attr('href'),
				success: function(data) {
					var $cf = $('.formWrapper', data);
					fullHtml = '<div id="' + $cf.attr('id') + '" class="' + $cf.attr('class') + '">';
					$cf.each(function() {
						var html = $(this).html();
						if (typeof html === 'string') {
							fullHtml += html;
						}
					});
				},
				async: false
			});
			return fullHtml + '</div>';
		}
	});

	$elem.colorbox(options);
}
